var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRichiestaModifica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.013,
    height: 16,
    viewBox: "0 0 16.013 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-7188629",
    transform: "translate(-12.529 -12.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9625",
    "data-name": "Tracciato 9625",
    d: "M28.442,14.29,21.8,20.934a.749.749,0,0,1-.124.08l-2.348.881a.2.2,0,0,1-.036.009.077.077,0,0,1-.071-.115l.881-2.348a.615.615,0,0,1,.08-.124l6.645-6.645a.3.3,0,0,1,.231-.1.24.24,0,0,1,.178.063l1.245,1.245a.305.305,0,0,1-.036.409ZM21.984,21.85l-2.348.881-.187.063h-.16a.973.973,0,0,1-.908-1.326l.881-2.339a1.24,1.24,0,0,1,.285-.445l4.341-4.341H13.418a.892.892,0,0,0-.889.889V27.686a.892.892,0,0,0,.889.889H25.871a.892.892,0,0,0,.889-.889V17.226l-4.332,4.332a1.342,1.342,0,0,1-.445.294Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichiestaModifica);
export default __webpack_public_path__ + "static/media/RichiestaModifica.43c74b6d0d69a47566e6ab1a37109f47.svg";
export { ForwardRef as ReactComponent };